// Annotated rather than left to infer its twelve literal keys: every caller
// passes a month straight off an API model, where it is a plain `number`. The
// read is therefore `string | undefined`, which is exactly what this returns at
// runtime for anything outside 1–12.
const MONTH_NAME: Record<number, string> = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};

export const getMonthName = (monthNumber: number) => {
  return MONTH_NAME[monthNumber];
};
